import PropTypes from 'prop-types'
import React from 'react'
import { page as pageIndex, screenSize } from '../../../globals'
import CheckboxesList from '../../FormComponents/CheckboxesList/CheckboxesList'
import STSComponent from '../../STSComponent/STSComponent'

class DeletedRecordLine extends STSComponent {
  render () {
    const { itemData, trackData, classNames, updateData, id } = this.props
    const values = Object.values(itemData)
    return <div className="deleted-records-line">
      <CheckboxesList
        location={{ page: pageIndex.dashboard, field: 'deletedRecords', section: 'deletedRecords' }}
        fieldData={[{
          id: id,
          text: window.innerWidth <= screenSize.extraSmall ? 'Select Record' : '',
          type: 'checkbox'
        }]}
        values={trackData.deletedRecords}
        updateData={updateData}
      />
      {values.map((item, i) => {
        return (
          <div className={`deleted-records-cell ${classNames[i + 1]}`} key={i}>
            {item}
            {i === 0 ? <div className="track-blue-button deleted-records">Show Detail</div> : null}
          </div>
        )
      })}
      <div className="deleted-records-cell small">
        <div className="track-blue-button deleted-records">Restore Record</div>
      </div>
    </div>
  }

  static propTypes = {
    itemData: PropTypes.object,
    trackData: PropTypes.object,
    classNames: PropTypes.array,
    updateData: PropTypes.func,
    id: PropTypes.number
  }
}

export default DeletedRecordLine



// WEBPACK FOOTER //
// ./src/components/ManagementDeletedRecordsArchive/components/DeletedRecordLine.js